// Quality warehouse catalogue. Independent of the catalogue in Flujos.
const warehouseNames = {
  '1': 'Betxí',
  '2': 'Ulldecona',
  '3': 'Alquerías',
}

export const getWarehouseLabel = (code, name) => (
  warehouseNames[String(code).trim()]
  || (name && String(name).trim() !== String(code) ? String(name).trim() : '')
  || `Almacen ${code}`
)
